import React from "react";
import "./SocialMedia.css";
import Icons from "./Icons";
// import hero_image_5 from "../../assets/images/hero_image_5.jpg";

export default function SocialMedia() {
  return (
    <div
      className="social_media"
      // style={{ backgroundImage: `url(${hero_image_5})` }}
    >
      {/* <div className="dark_layer"></div> */}
      <div className="container padding_top_bottom">
        <h2>Follow us on the following social media platforms.</h2>
        <Icons />
      </div>
    </div>
  );
}
